module.exports = __webpack_public_path__ + "img/behold-11.0cba5d0a.png";